module.exports = __webpack_public_path__ + "static/media/FILMM2021.25dff1e9.pdf";